import { render, staticRenderFns } from "./oficioGeneradoTimeline.vue?vue&type=template&id=b5fa5664"
import script from "./oficioGeneradoTimeline.vue?vue&type=script&lang=js"
export * from "./oficioGeneradoTimeline.vue?vue&type=script&lang=js"
import style0 from "./oficioGeneradoTimeline.vue?vue&type=style&index=0&id=b5fa5664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports